var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 292,
    viewBox: "0 0 345 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.595 291.475C269.602 291.475 345 281.019 345 268.121C345 255.222 269.602 244.766 176.595 244.766C83.5878 244.766 8.19043 255.222 8.19043 268.121C8.19043 281.019 83.5878 291.475 176.595 291.475Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 226.187C146.328 223.789 146.233 220.465 145.661 216.562C145.178 213.274 143.638 202.771 138.1 194.834C129.73 182.838 120.242 188.186 110.516 175.784C104.949 168.686 106.515 164.967 100.149 159.285C94.5257 154.266 88.4893 152.418 82.0573 151.36C65.7813 148.683 39.2275 151.194 39.2275 151.194C41.4692 176.932 50.1208 187.573 57.5869 192.539C68.0648 199.507 76.1244 195.238 85.4632 203.58C97.6203 214.438 89.6398 226.741 100.978 238.039C100.978 238.039 105.942 242.984 144.462 250.305L146.295 226.187Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.462 250.305C144.462 250.305 114.704 199.66 103.369 189.735C92.0337 179.809 39.2275 151.194 39.2275 151.194",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4393 172.792L44.2002 174.653",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3066 176.906L86.5125 152.255",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4191 186.672L70.6504 197.301",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.591 199.306L115.293 180.617",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.875 212.547L93.0059 217.638",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.146 223.71L138.634 195.626",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.76 234.263L102.524 239.015",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.602 230.153C127.716 227.924 126.357 224.889 124.336 221.501C122.634 218.646 117.197 209.53 109.045 204.312C96.7249 196.426 90.0014 204.996 76.2737 197.252C68.4173 192.82 68.4424 188.785 60.3881 185.967C53.2735 183.478 46.9883 184.078 40.6415 185.559C24.5778 189.306 1 201.775 1 201.775C12.9084 224.701 24.9704 231.228 33.7674 232.963C46.1133 235.397 51.9297 228.373 63.7475 232.512C79.1317 237.899 76.4594 252.319 91.2547 258.425C91.2547 258.425 97.7316 261.098 136.125 253.14L128.602 230.153Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.125 253.14C136.125 253.14 89.2702 217.714 75.0022 212.874C60.7335 208.034 1 201.775 1 201.775",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5668 207.129L14.5615 221.552",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4838 208.306L45.1006 184.683",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1825 211.554L47.6602 232.372",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2585 218.576L82.5361 199.891",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8982 227.265L76.0898 242.62",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.883 234.801L109.841 204.84",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.03 242.024L93.0576 258.736",
    stroke: "#D6D6D6",
    strokeWidth: 0.4657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.017 253.526H135.559L145.33 186.435H227.246L237.017 253.526Z",
    fill: "#FF92C9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.435 198.264H60.1404C53.7305 198.264 48.5342 193.068 48.5342 186.658V27.7156C48.5342 21.3057 53.7305 16.1094 60.1404 16.1094H312.435C318.845 16.1094 324.042 21.3057 324.042 27.7156V186.658C324.042 193.068 318.845 198.264 312.435 198.264Z",
    fill: "#FDB6D6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M305.75 179.153H66.826C60.416 179.153 55.2197 173.957 55.2197 167.547V33.1997C55.2197 26.7897 60.416 21.5934 66.826 21.5934H305.751C312.161 21.5934 317.357 26.7897 317.357 33.1997V167.547C317.357 173.957 312.161 179.153 305.75 179.153Z",
    fill: "#FFDEEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.521 258.411H114.054V251.432C114.054 246.036 118.428 241.661 123.825 241.661H248.751C254.147 241.661 258.521 246.036 258.521 251.432V258.411Z",
    fill: "#FDB6D6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7666 179.153H303.965",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.413 254.922V251.258C120.413 249.041 122.21 247.245 124.426 247.245H232.777",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.262 203.625L225.1 232.938",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.865 194.923C186.969 194.923 189.486 192.406 189.486 189.302C189.486 186.197 186.969 183.681 183.865 183.681C180.761 183.681 178.244 186.197 178.244 189.302C178.244 192.406 180.761 194.923 183.865 194.923Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M263.834 32.288H293.67C299.355 32.288 303.964 36.8968 303.964 42.5824V104.575",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M286.603 51.9258C288.326 47.7803 290.03 44.573 291.715 42.3062C293.399 40.0395 295.592 38.2315 298.296 36.8832C299.876 36.0568 301.522 35.4641 303.239 35.1057C304.953 34.748 306.584 34.2923 308.133 33.7406C309.679 33.1897 311.103 32.4409 312.403 31.4974C313.702 30.5539 314.774 29.064 315.622 27.0255C317.053 23.5831 317.105 20.7807 315.777 18.6219C314.45 16.4632 312.485 14.8425 309.886 13.762C306.159 12.2135 303.164 12.1846 300.898 13.6729C298.629 15.162 296.589 17.5901 294.778 20.9579L281.181 15.3059C282.612 11.8635 284.473 8.96894 286.767 6.62531C289.058 4.28245 291.651 2.55745 294.542 1.45107C297.432 0.34622 300.555 -0.128589 303.911 0.0296818C307.263 0.187192 310.698 0.996809 314.213 2.45777C321.802 5.61253 327.149 9.64919 330.258 14.567C333.363 19.4856 333.472 25.4222 330.579 32.3793C329.644 34.6293 328.597 36.5004 327.441 37.9979C326.282 39.4939 324.961 40.7372 323.479 41.7287C321.995 42.7187 320.337 43.5344 318.506 44.1743C316.673 44.8142 314.652 45.4153 312.44 45.9792C310.396 46.5316 308.689 47.1206 307.317 47.7438C305.945 48.3692 304.777 49.1416 303.82 50.0607C302.86 50.9807 302.054 52.0277 301.404 53.1972C300.751 54.3691 300.104 55.7288 299.462 57.2735L286.603 51.9258ZM277.725 72.0954L283.465 58.2863L297.695 64.2016L291.955 78.0107L277.725 72.0954Z",
    fill: "#674DA2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.685 72.65V61.3733C203.685 57.6744 200.687 54.6757 196.988 54.6757H131.528C127.829 54.6757 124.83 57.6744 124.83 61.3733V72.65V147.777C124.83 151.476 127.829 154.475 131.528 154.475H236.205C239.904 154.475 242.902 151.476 242.902 147.777V79.3476C242.902 75.6488 239.904 72.65 236.205 72.65H203.685Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M197.054 88.4011L183.866 101.589L170.678 88.4019L162.72 96.3596L175.907 109.548L162.72 122.736L170.678 130.694L183.866 117.506L197.054 130.694L205.012 122.736L191.824 109.548L205.012 96.3596L197.054 88.4011Z",
    fill: "#D6D6D6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9723 257.761V249.078H24.9824V272.955L61.0864 273.534V269.193L40.9723 257.761Z",
    fill: "#F7A99C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3652 273.534V271.476C62.3652 269.371 61.2108 267.437 59.3588 266.437L44.1321 258.219C39.5673 259.466 36.0397 259.291 33.6291 258.882C29.6259 258.203 25.8001 256.384 24.5126 257.905C24.1443 258.341 24.1002 258.911 24.1146 259.304V271.93C24.1146 272.816 24.8329 273.534 25.7186 273.534H62.3652Z",
    fill: "#F3DA6D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3646 272.159H24.1133",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9367 263.684L51.7939 266.516",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3674 262.797L50.2246 265.63",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7275 261.976L48.584 264.808",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3122 260.475C45.7175 261.465 41.435 262.734 36.0287 262.705C30.8126 262.677 26.6725 261.451 24.1143 260.475",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5563 257.761V249.078H70.5664V272.955L106.67 273.534V269.193L86.5563 257.761Z",
    fill: "#F7A99C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.948 273.534V271.476C107.948 269.371 106.794 267.437 104.942 266.437L89.7151 258.219C85.1503 259.466 81.6227 259.291 79.2121 258.882C75.209 258.203 71.3831 256.384 70.0956 257.905C69.7273 258.341 69.6832 258.911 69.6976 259.304V271.93C69.6976 272.816 70.4159 273.534 71.3016 273.534H107.948Z",
    fill: "#F3DA6D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.948 272.159H69.6973",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5197 263.684L97.377 266.516",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9504 262.797L95.8076 265.63",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3107 261.976L94.168 264.808",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8952 260.475C91.3005 261.465 87.018 262.734 81.6117 262.705C76.3964 262.677 72.2555 261.451 69.6973 260.475",
    stroke: "#3897E9",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3661 134.108C77.3661 134.108 90.5345 175.929 92.5601 181.717C94.5856 187.505 96.4674 195.609 96.0329 202.699C95.5984 209.79 88.7973 253.491 88.7973 253.491H68.9724C68.9724 253.491 67.5723 207.329 66.8974 203.712C66.2224 200.095 60.4341 179.631 60.4341 179.631C60.4341 179.631 58.5532 203.567 56.9613 209.934C55.3695 216.301 42.6355 254.215 42.6355 254.215H24.1133L31.9279 134.108H77.3661Z",
    fill: "#369AD7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.589 108.614C107.589 108.614 113.876 103.28 115.467 99.7906C116.829 96.804 118.733 91.5567 119.254 90.1064C119.332 89.8872 119.562 89.7662 119.788 89.8195L120.165 89.9085C121.331 90.1847 122.052 91.3566 121.772 92.5223L121.144 95.1383L127.787 90.7752C128.357 90.4009 129.125 90.585 129.463 91.1777C129.761 91.7005 129.619 92.364 129.133 92.7178L124.751 95.9137L132.03 92.4957C132.594 92.2309 133.266 92.4439 133.575 92.9849L133.584 93.0009C133.911 93.5739 133.711 94.3028 133.138 94.6293L133.22 94.6057C133.852 94.4238 134.522 94.7305 134.798 95.327C135.117 96.0179 134.793 96.8352 134.088 97.1205L133.624 97.3077C134.229 97.119 134.863 97.4956 134.986 98.1165C135.167 99.0228 134.73 99.9382 133.911 100.365C131.951 101.385 130.68 101.653 128.818 103.047C127.344 104.15 127.86 104.852 126.288 106.863C124.373 109.313 122.743 109.382 119.445 111.806C118.192 112.727 116.463 114.162 114.635 116.298L107.589 108.614Z",
    fill: "#F7A99C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.57 91.4403C129.57 91.4403 129.904 92.1175 129.269 92.5999C128.635 93.0824 123.685 96.7469 123.685 96.7469",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.139 94.6293L126.322 97.7932",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M133.84 97.2666L126.987 100.421",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.641 90.0851C120.641 90.0851 121.839 90.8429 121.805 91.683C121.772 92.5231 120.563 97.9195 120.563 97.9195",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9741 253.492C68.9741 253.492 67.1798 206.16 67.0398 204.936C66.8998 203.713 60.1543 178.66 60.1543 178.66L61.3489 167.587C61.3489 167.587 74.9579 201.088 74.9579 203.297C74.9579 205.508 76.4699 253.492 76.4699 253.492H68.9741Z",
    fill: "#1775AF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7344 207.037L62.5708 154.729",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5599 249.476H68.8203L68.9733 253.492H88.7982L89.5599 249.476Z",
    fill: "#262626"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8378 250.628H24.3469L24.1133 254.216H42.6363L43.8378 250.628Z",
    fill: "#262626"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7666 185.853C93.391 194.114 93.8072 203.065 91.9597 211.534",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M112.816 102.989C112.816 102.989 109.459 105.574 105.635 106.245C101.154 107.032 97.2676 104.378 96.2244 103.666C93.3832 101.726 92.3339 99.4268 90.4551 96.737C84.8898 88.7702 81.433 83.8212 76.5935 81.0187C74.0924 79.5699 69.9096 77.9347 63.3155 78.4407C61.8363 77.9104 59.4782 78.3304 57.8985 78.3304C56.5852 78.3304 55.2726 78.3304 53.9593 78.3304C51.3706 78.6408 32.3051 80.8559 29.0636 77.8792C27.786 76.7058 27.7655 75.55 27.7655 75.55C27.7487 74.5943 28.3521 73.5998 29.9318 72.3968C33.7919 69.4573 40.873 67.2629 43.2448 66.5636L41.7975 55.7555C41.7975 55.7555 41.7975 55.7555 38.6139 55.7555C35.4302 55.7555 24.1427 57.6365 18.0653 59.7602C9.54378 62.7377 4.97828 64.9109 2.72596 69.8469C-0.0955185 76.0324 2.9101 82.6805 3.6908 84.4078C7.60344 93.0617 16.2794 96.5643 21.5199 98.6796C26.1417 100.545 30.2552 101.295 33.1147 101.628L30.6547 140.989L75.8958 143.449H82.69C83.2105 137.435 80.6081 118.748 80.9452 112.644C86.7213 120.682 96.2891 124.742 105.372 122.996C115.428 121.064 120.485 112.865 121.308 111.481C117.799 104.557 112.816 102.989 112.816 102.989Z",
    fill: "#674DA2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6059 100.138H56.1699V81.3528H59.0196V97.7247C59.0196 99.0578 57.9391 100.138 56.6059 100.138Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7591 141.373C81.2007 141.662 59.7862 145.253 44.6546 129.276C31.8864 115.795 33.3961 98.7344 33.6624 96.2112C32.868 108.045 32.0729 119.879 31.2785 131.713H31.2351L30.6553 140.988L37.747 141.374L37.7425 141.324C48.3192 142.161 59.2346 142.785 70.4725 143.154C74.5891 143.288 78.6623 143.386 82.6914 143.449C82.7134 142.756 82.7362 142.065 82.7591 141.373Z",
    fill: "#674DA2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7629 64.1104C71.5383 60.1308 71.4173 57.0202 71.1921 55.0319C71.0209 53.5192 70.7576 52.374 69.9541 51.2852C69.7844 51.0554 68.4498 49.3007 66.1594 48.8426C63.4201 48.294 62.7284 50.2838 58.8318 50.7662C55.4716 51.1817 54.8096 49.8478 52.5496 50.8058C50.0812 51.8521 48.863 54.2954 48.4932 55.0373C48.3319 55.3614 47.5276 57.0187 47.4462 59.341C47.3815 61.1801 47.8015 62.5635 47.9682 63.1296C48.6682 65.5121 49.4923 69.1355 50.4997 74.9284C51.0255 74.9086 51.5521 74.8896 52.0779 74.8698C58.3067 71.2821 64.5348 67.6959 70.7629 64.1104Z",
    fill: "#262626"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4397 83.6827C54.4965 83.6941 52.1019 81.317 52.0912 78.3745L52.0479 66.9075L62.7053 66.8672L62.7486 78.3342C62.7593 81.2767 60.3829 83.6713 57.4397 83.6827Z",
    fill: "#F7A99C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7362 75.1238L55.7959 71.5581C55.8659 72.1592 56.2608 74.9739 58.7361 76.918C60.3165 78.1591 61.9783 78.4429 62.7454 78.5235L62.7362 75.1238Z",
    fill: "#FF7769"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7893 63.3548C51.7558 63.1813 51.2993 62.9196 51.1593 62.8305C50.9226 62.6791 50.6662 62.5581 50.3984 62.4722C49.8786 62.3048 49.3072 62.2659 48.773 62.3885C47.7108 62.6319 46.7688 63.5245 46.5915 64.6179C46.4888 65.2533 46.6356 65.91 46.9073 66.4928C47.3166 67.3694 48.0106 68.106 48.8491 68.5884C49.5438 68.9886 50.3344 69.2154 51.1334 69.2626C51.2932 69.2717 52.9314 69.2344 52.9193 69.1713C52.5419 67.2325 52.1652 65.2936 51.7893 63.3548Z",
    fill: "#F7A99C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3283 63.4659C50.4546 64.3212 51.2064 68.8342 55.2743 72.0224C56.0238 72.6099 61.0047 76.5141 65.5626 74.6088C71.4194 72.1602 70.7802 62.5407 70.7391 62.0194C70.5999 60.2579 70.1882 55.0707 65.8929 52.3033C62.3873 50.0449 58.5881 50.875 58.0493 51.0021C57.4817 51.1353 53.865 52.0484 51.6515 55.5942C49.642 58.8122 50.1221 62.0658 50.3283 63.4659Z",
    fill: "#F7A99C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4145 62.0262C67.5088 62.7772 68.0879 63.3228 68.708 63.2452C69.3282 63.1676 69.7543 62.4957 69.6599 61.7446C69.5656 60.9936 68.9865 60.4481 68.3664 60.5257C67.7462 60.6033 67.3201 61.2752 67.4145 62.0262Z",
    fill: "#262626"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6469 62.8762C60.7412 63.6272 61.3203 64.1728 61.9404 64.0952C62.5606 64.0175 62.9867 63.3457 62.8923 62.5946C62.798 61.8436 62.2189 61.298 61.5988 61.3756C60.9794 61.4533 60.5525 62.1251 60.6469 62.8762Z",
    fill: "#262626"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3708 63.1501L66.4079 64.5518C66.5989 64.809 66.5274 65.175 66.2535 65.3416L65.3008 65.9214",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3774 66.4136C58.4831 67.256 59.2524 67.8541 60.0948 67.7475C60.9371 67.6418 61.5352 66.8725 61.4286 66.0301C61.3229 65.1878 60.5536 64.5897 59.7113 64.6962C58.8689 64.802 58.2716 65.5713 58.3774 66.4136Z",
    fill: "#FF7769"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0736 67.208C51.0789 67.0391 51.0926 65.8946 50.175 65.069C49.4559 64.4223 48.6189 64.3797 48.3906 64.3759",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2643 65.2959C50.2133 65.2875 49.5977 65.2023 49.1678 65.668C48.814 66.0507 48.8467 66.524 48.8535 66.6024",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1938 62.415C50.1938 62.415 50.9509 62.4819 51.5216 63.0488C52.0923 63.6149 52.2947 64.5851 52.2947 64.5851C53.7534 64.4078 57.0946 63.7922 60.1253 61.1618C61.7681 59.7358 62.771 58.1942 63.3623 57.0825C63.9147 57.5793 64.8575 58.3258 66.1914 58.9011C67.9316 59.6513 70.1055 60.0105 70.3939 59.4261C70.4472 59.318 70.3886 59.0045 70.2699 58.3783C70.2273 58.1516 70.1824 57.816 70.072 57.4949C69.8567 56.8664 69.5767 56.2599 69.2426 55.6854C68.573 54.5364 67.682 53.5161 66.6334 52.6981C65.9517 52.1669 65.2037 51.721 64.4078 51.3824C61.8815 50.308 58.3737 50.3073 55.3544 51.9174C55.3544 51.9174 51.9835 53.7154 50.4974 57.2339C49.9869 58.443 49.8583 59.6521 49.8263 60.0714C49.7624 60.9015 49.856 61.444 49.9823 61.861C50.0538 62.0969 50.1337 62.2864 50.1938 62.415Z",
    fill: "#262626"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9408 63.9818C70.2322 63.9453 70.513 63.997 70.7626 64.1104C70.7329 64.936 70.6537 65.9374 70.4719 66.9996C70.4224 67.011 70.3752 67.027 70.3243 67.0338C69.4819 67.1396 68.7126 66.5423 68.6069 65.6999C68.5011 64.8576 69.0977 64.0876 69.9408 63.9818Z",
    fill: "#FF7769"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.656 51.1975C58.1553 51.0028 57.4218 50.7372 56.5186 50.4777C54.5387 49.9101 53.5487 49.6262 52.6478 49.7419C50.0105 50.0805 48.4955 53.5564 47.8601 55.0143C47.3792 56.1176 46.5924 57.9903 47.0094 60.3362C47.1951 61.3801 47.5626 62.1966 47.8548 62.7361",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6562 50.8841C59.548 50.4945 60.5015 50.1787 61.3605 49.7321C62.2622 49.2634 63.0498 48.6539 64.0154 48.294C65.0297 47.9158 66.1619 47.7644 67.1975 48.0786C68.0901 48.3495 68.8533 48.9461 69.4833 49.6339C70.3318 50.5607 70.9778 51.6793 71.3141 52.8899C71.9624 55.2229 71.3833 57.654 71.0014 59.9794",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5158 69.1317C66.5158 69.8896 65.7777 70.5036 64.8677 70.5036C63.9568 70.5036 63.2188 69.8896 63.2188 69.1317C63.2188 68.3738 63.9568 67.7598 64.8677 67.7598C65.7777 67.7605 66.5158 68.3746 66.5158 69.1317Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0469 57.6098L45.0913 55.7555C45.0913 55.7555 45.713 53.0733 46.5584 52.5064C47.4037 51.9395 51.8962 50.1947 51.8962 50.1947L52.5506 50.8057C52.5506 50.8057 49.0351 54.0168 48.3069 55.4428C47.578 56.8687 47.441 60.8384 47.441 60.8384L44.0017 65.2852L43.1601 65.9221L42.0469 57.6098Z",
    fill: "#F7A99C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6625 97.9194L32.0615 118.489",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1611 99.6011L81.3885 122.297",
    stroke: "#262626",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87562 67.208C9.23949 67.714 5.94929 70.4358 5.41665 75.244C4.83683 80.4822 7.98703 84.0676 8.47934 84.6094",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M88.041 114.155C88.8872 115.095 92.1774 118.524 97.7062 119.272C102.95 119.981 106.862 117.826 107.989 117.15",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M231.798 132.176L238.855 128.403L249.324 130.322L254.558 124.739L266.946 128.054L273.838 118.632L286.145 126.176L281.958 99.5722L265.719 88.2018L228.394 94.0761C226.996 94.296 226.042 95.607 226.262 97.0048L231.798 132.176Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M269.511 101.531L281.957 99.5722L265.718 88.2018L267.596 100.137C267.74 101.051 268.597 101.675 269.511 101.531Z",
    fill: "#D6D6D6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M265.718 88.201L267.596 100.136C267.74 101.05 268.598 101.674 269.512 101.53L281.958 99.5714",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M236.828 167.107C237.048 168.505 238.359 169.459 239.757 169.239L288.651 161.544C290.049 161.324 291.003 160.013 290.783 158.615L286.145 129.142L273.838 121.598L266.945 131.02L254.557 127.705L249.323 133.288L238.854 131.369L231.797 135.142L236.828 167.107Z",
    fill: "#F5F5F5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M231.806 132.176L238.864 128.403L249.333 130.322L254.567 124.739L266.955 128.054L273.847 118.632L286.154 126.176L281.967 99.5722L265.727 88.2018L228.403 94.0761C227.005 94.296 226.051 95.607 226.271 97.0048L231.806 132.176Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M236.838 167.107C237.058 168.505 238.369 169.459 239.767 169.239L288.661 161.544C290.059 161.324 291.013 160.013 290.793 158.615L286.154 129.142L273.847 121.598L266.955 131.02L254.567 127.705L249.333 133.288L238.864 131.369L231.807 135.142L236.838 167.107Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6489 49.4276L41.4147 50.6055L30.4971 40.7479L33.6397 37.7506L42.6489 49.4276Z",
    fill: "#FF7129"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3471 47.4067L43.6693 47.7171L39.9248 33.4926L44.1951 32.7035L45.3471 47.4067Z",
    fill: "#FF7129"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M39.529 52.1106L39.389 53.8113L24.6797 53.7002L25.0366 49.3721L39.529 52.1106Z",
    fill: "#FF7129"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M215.262 267.783C211.571 264.156 211.52 258.223 215.147 254.533L258.286 210.638L271.65 223.773L228.512 267.667C224.884 271.358 218.952 271.41 215.262 267.783Z",
    fill: "#F3DA6D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.235 227.436C313.159 227.388 330.082 210.386 330.034 189.463C329.986 168.539 312.985 151.615 292.061 151.664C271.137 151.712 254.214 168.713 254.262 189.637C254.31 210.561 271.311 227.484 292.235 227.436Z",
    fill: "#DCF0FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.684 202.912C257.961 206.311 259.742 209.561 262.028 212.548L330.016 189.032C329.965 185.356 329.38 181.688 328.267 178.151L256.684 202.912Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.343 192.063C254.484 194.213 254.809 196.351 255.316 198.455L326.593 173.801C325.705 171.857 324.646 169.974 323.412 168.173L254.343 192.063Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M322.786 158.374C305.564 141.448 277.88 141.688 260.953 158.911C244.027 176.134 244.267 203.818 261.491 220.744C278.713 237.671 306.397 237.431 323.323 220.207C340.25 202.984 340.01 175.3 322.786 158.374ZM266.899 215.241C252.716 201.301 252.518 178.504 266.457 164.319C280.396 150.136 303.194 149.938 317.378 163.877C331.561 177.816 331.759 200.614 317.82 214.799C303.881 228.982 281.083 229.18 266.899 215.241Z",
    fill: "#F3DA6D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M261.313 227.811L227.203 262.519",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M295.274 148.977C284.526 147.893 273.384 151.602 265.431 158.912C257.478 166.222 252.845 177.012 253.021 187.813",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/OBJECT.6256542b7c2440d0f35b29a012d3c6ad.svg";
export { ForwardRef as ReactComponent };